export const PRESET_LIGHT_TYPES = [
    "Bulkhead",
    "Twin Spot",
    "LED Spot",
    "Box Exit",
    "Hanging Man",
    "Round Bulk",
    "Square Bulk",
    "4ft Batten",
    "5ft Batten",
    "6ft Batten",
    "Flat Round",
    "Ceiling Panel",
];

export function getPresetTypeImagePath(type) {
    const fileName = String(type)
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/^-+|-+$/g, "");
    return `/img/elight-types/${fileName}.jpg`;
}

export function buildPresetTypeImages() {
    const images = {};
    PRESET_LIGHT_TYPES.forEach((type) => {
        images[type] = getPresetTypeImagePath(type);
    });
    return images;
}

export function normalizeTypeValue(type) {
    if (typeof type !== "string") {
        return "";
    }
    return type.trim().toLowerCase();
}

export function findPresetType(type) {
    const normalized = normalizeTypeValue(type);
    if (!normalized) {
        return "";
    }
    if (normalized === "bulk") {
        return "Bulkhead";
    }
    const match = PRESET_LIGHT_TYPES.find(
        (preset) => normalizeTypeValue(preset) === normalized
    );
    return match || "";
}

export function normalizeLight(light, options) {
    const opts = options || {};
    const normalized = { ...(light || {}) };
    const rawTypeValue =
        typeof normalized.type === "string" ? normalized.type.trim() : "";
    const presetType = findPresetType(normalized.type);
    const normalizedCurrentType = normalizeTypeValue(normalized.type);
    if (presetType) {
        normalized.type = presetType;
    } else if (
        normalizedCurrentType === "other" ||
        (!normalizedCurrentType && normalized.other_type_label)
    ) {
        normalized.type = "Other";
    } else if (normalizedCurrentType) {
        normalized.type = "Other";
        if (!normalized.other_type_label) {
            normalized.other_type_label = rawTypeValue;
        }
    } else {
        normalized.type = "";
    }

    if (normalized.type !== "Other") {
        normalized.other_type_label = "";
        normalized.photo_url = "";
    } else {
        if (typeof normalized.other_type_label !== "string") {
            normalized.other_type_label = "";
        } else {
            normalized.other_type_label = normalized.other_type_label.trim();
        }
        if (
            opts.markAsExisting &&
            (!normalized.other_type_label ||
                normalized.other_type_label.length < 1)
        ) {
            normalized.other_type_label = "Other";
        }
        if (!normalized.photo_url) {
            normalized.photo_url = "";
        }
    }

    normalized.maintained = !!normalized.maintained;
    normalized.high = !!normalized.high;
    normalized.not_accessible = !!normalized.not_accessible;
    if (normalized.not_accessible) {
        normalized.tested = false;
        normalized.test_result = null;
    }
    if (!normalized.test_result) {
        normalized.test_result = null;
    }
    if (opts.markAsExisting) {
        normalized._is_existing_light = true;
    } else {
        normalized._is_existing_light = !!normalized._is_existing_light;
    }
    return normalized;
}

export function normalizeLightsCollection(lights, options) {
    if (!Array.isArray(lights)) {
        return [];
    }
    return lights.map((light) => normalizeLight(light, options));
}

export function isExistingLoadedLight(light) {
    return !!(light && light._is_existing_light);
}

export function serializeFormLightForSave(light) {
    const serializable = { ...(light || {}) };
    delete serializable._is_existing_light;
    return serializable;
}

export function serializeSiteLightForSave(light) {
    const serializable = serializeFormLightForSave(light);
    if (
        serializable.type === "Other" &&
        serializable.other_type_label
    ) {
        serializable.type = serializable.other_type_label.trim();
    }
    delete serializable.other_type_label;
    delete serializable.image_url;
    return serializable;
}

export function serializeLightsForSave(lights, context) {
    if (!Array.isArray(lights)) {
        return [];
    }
    const serialize =
        context === "site" ? serializeSiteLightForSave : serializeFormLightForSave;
    return lights.map((light) => serialize(light));
}

export function getLightTypeDisplay(light) {
    if (light.type === "Other") {
        return light.other_type_label || "Other";
    }
    return light.type || "-";
}

export function getLightTableImage(light, presetTypeImages) {
    if (light.type === "Other") {
        return light.photo_url || "";
    }
    if (!light.type) {
        return "";
    }
    return presetTypeImages[light.type] || "";
}

export function getLightTestResultDisplay(light) {
    if (light.not_accessible) {
        return "N/A";
    }
    if (light.test_result === "passed") {
        return "P";
    }
    if (light.test_result === "failed") {
        return "F";
    }
    return "-";
}

export function isLightInvalid(light) {
    if (
        typeof light.light_location === "undefined" ||
        light.light_location === null ||
        light.light_location.length < 1
    ) {
        return true;
    }
    if (!light.type || light.type.length < 1) {
        return true;
    }
    if (light.type !== "Other") {
        return false;
    }
    if (isExistingLoadedLight(light)) {
        return false;
    }
    if (!light.other_type_label || light.other_type_label.length < 1) {
        return true;
    }
    return !light.photo_url;
}



// WEBPACK FOOTER //
// ./resources/assets/js/include/ElightingLights.js